<template>
  <v-application>
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-card v-if="!create_transaction">
          <v-row>
            <v-col sm6>
              <v-btn text @click="toTransaction">
                <v-icon>mdi-arrow-left</v-icon>
                Транзакции поставщиков
              </v-btn>
            </v-col>

            <v-col sm6>
              <v-flex>
                <v-combobox
                  v-model="store"
                  :label="$t('store')"
                  v-bind:items="stores"
                  hide-details
                  outlined
                  dense
                  item-text="name"
                  class="mx-1"
                />
              </v-flex>
            </v-col>
          </v-row>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold"
                >{{ current_supplier.supplier_name }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ current_supplier.phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-spacer></v-spacer>
            <v-list-item-content class="text-right">
              <v-list-item-title class="font-weight-bold">
                {{
                  (current_supplier.saved_balance
                    ? Math.round(
                        current_supplier.saved_balance
                      ).toLocaleString()
                    : current_supplier.saved_balance) +
                  " " +
                  $t("uzs")
                }}
              </v-list-item-title>
              <v-list-item-title class="font-weight-bold">
                {{
                  (current_supplier.balance_usd
                    ? current_supplier.balance_usd.toLocaleString()
                    : current_supplier.balance_usd) +
                  " " +
                  $t("usd")
                }}
              </v-list-item-title>
              <v-list-item-subtitle class="primary--text">
                {{ $t("report_by_items") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium primary--text">
                {{ $t("transaction_documents") }}
              </v-list-item-title>
            </v-list-item-content>
            <v-spacer></v-spacer>
            <v-btn icon @click="exportXLSX()">
              <v-icon>mdi-download</v-icon>
            </v-btn>
            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title v-if="wait">Iltimos, kutib turing!</v-card-title>
                <v-card-title v-else>Excel yuklashga tayyor!</v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    text
                    color="primary"
                    @click="saveExcel"
                    :disabled="wait"
                  >
                    Save Excel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn
              v-if="access.create_supplier_create_doc"
              text
              color="primary"
              @click="create_transaction = true"
            >
              {{ $t("create_document") }}
            </v-btn>
          </v-list-item>

          <v-data-table
            id="table-data"
            :items="current_supplier.transactions"
            :headers="transaction_headers"
            :items-per-page="200000"
            hide-default-footer
            disable-sort
            :loading="data_loading"
            v-on:click:row="editTransaction"
          >
            <template #[`item.document_id`]="{ item }">
              <span
                v-if="item.purchase_id"
                class="primary--text"
                style="cursor: pointer"
                @click="docClicked(item)"
                >{{ item.document_id }}</span
              >
              <span v-else>{{ item.document_id }}</span>
            </template>
            <template #[`item.status`]="{ item }"
              >{{ $t(item.status) }}
            </template>
            <template #[`item.balance_type`]="{ item }"
              >{{ $t(item.balance_type) }}
            </template>
            <template #[`item.debt`]="{ item }">
              <p v-if="item.balance > 0" style="margin-top: 15px">
                {{ item.balance ? item.balance.toLocaleString() : item.balance
                }}{{ item.currency == "usd" ? " $" : "" }}
              </p>
            </template>
            <template #[`item.balance`]="{ item }">
              <p v-if="item.balance < 0" style="margin-top: 15px">
                {{
                  item.balance
                    ? (item.balance * -1).toLocaleString()
                    : item.balance * -1
                }}{{ item.currency == "usd" ? " $" : "" }}
              </p>
            </template>
            <template #[`item.date`]="{ item }"
              >{{ date_ddmmyy_hhmm(item.date) }}
            </template>

            <template #footer>
              <v-pagination
                v-model="per_page"
                :length="length"
                total-visible="7"
              />
            </template>
          </v-data-table>
        </v-card>
        <v-card v-else>
          <v-list-item-content class="ml-5 pl-5">
            <v-list-item-title class="font-weight-bold"
              >{{ current_supplier.supplier_name }}
            </v-list-item-title>
            <v-list-item-subtitle
              >{{ current_supplier.phone_number }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-form v-model="is_valid">
            <v-card-text>
              <v-layout row class="px-5">
                <v-flex px-2 md4>
                  <v-autocomplete
                    v-model="current_transaction.service"
                    :items="services"
                    item-text="name"
                    item-value="_id"
                    :label="$t('store')"
                    :rules="[fieldRules.require]"
                  ></v-autocomplete>
                </v-flex>
                <v-flex px-2 md4>
                  <v-select
                    v-model="current_transaction.status"
                    :items="transaction_status"
                    :label="$t('status')"
                    :append-icon="null"
                    item-text="text"
                    item-value="value"
                    ref="status"
                    :rules="[fieldRules.require]"
                    :readonly="
                      current_transaction.status == 'active' &&
                      current_transaction._id != undefined
                    "
                  ></v-select>
                </v-flex>
                <v-flex px-2 md4>
                  <v-text-field
                    v-model="current_transaction.document_id"
                    :readonly="
                      current_transaction &&
                      current_transaction._id != undefined
                    "
                    label="Id"
                    ref="document_id"
                    :rules="[fieldRules.require]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <p class="ma-0 pa-0 primary--text px-5 my-2">
                {{ $t("balance") }}
              </p>
              <v-layout row class="px-5">
                <v-flex
                  px-2
                  :class="
                    can_get_back && current_transaction._id == undefined
                      ? 'md4'
                      : 'md6'
                  "
                >
                  <vuetify-money
                    v-model="current_transaction.balance"
                    :options="
                      current_transaction.currency == 'usd'
                        ? moneyOptionsUSD
                        : moneyOptions
                    "
                    :readonly="
                      current_transaction &&
                      current_transaction._id != undefined
                    "
                    :label="$t('balance')"
                    ref="balance"
                    :rules="[fieldRules.require]"
                  />
                </v-flex>
                <v-flex
                  v-if="can_get_back && current_transaction._id == undefined"
                  md2
                  px-2
                >
                  <v-checkbox
                    v-model="current_transaction.return_money"
                    :label="$t('get_back')"
                  />
                </v-flex>
                <v-flex px-2 md3>
                  <v-select
                    v-model="current_transaction.balance_type"
                    :label="$t('balance_type')"
                    :items="balance_type"
                    :append-icon="null"
                    item-text="text"
                    item-value="value"
                    ref="currency"
                    :rules="[fieldRules.require]"
                  ></v-select>
                </v-flex>
                <v-flex px-2 md3>
                  <v-select
                    v-model="current_transaction.currency"
                    :label="$t('currency')"
                    :items="transfer_currencies"
                    :append-icon="null"
                    ref="currency"
                    :rules="[fieldRules.require]"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-form>
          <v-card-actions class="px-5">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              large
              text
              width="200"
              :elevation="0"
              @click="cancelClicked"
              >{{ $t("cancel") }}
            </v-btn>
            <v-btn
              color="primary"
              large
              width="200"
              :loading="loading_transaction"
              :elevation="0"
              :disabled="saveDisabled"
              @click="adjustTransaction"
              >{{ $t("adjust") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
import Userable from "../../mixins/userable";
import Suppliers from "../../mixins/inventory/supplier";
import Services from "../../mixins/services";
import SupplierTransactions from "../../mixins/inventory/supplier_transaction";
import fileSaver from "file-saver";
import xlsx from "xlsx";

export default {
  name: "SupplierTransactionDetail",
  mixins: [Suppliers, SupplierTransactions, Services, Userable],
  computed: {
    form() {
      return {
        status: this.current_transaction.status,
        document_id: this.current_transaction.document_id,
        balance: this.current_transaction.balance,
        currency: this.current_transaction.currency,
      };
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
    supplier_id() {
      return this.$route.query.id;
    },
    can_get_back() {
      let can_get_back = false;
      if (this.access && this.access.inv_supplier_transaction_corrector) {
        can_get_back = true;
      }
      return can_get_back;
    },
  },
  data: () => ({
    countries: [{ text: "Uzbekistan", value: "uz" }],
    current_supplier: {
      supplier_name: "",
      phone_number: "",
      balance: 0,
      balance_usd: 0,
      saved_balance: 0,
      transactions: [],
    },
    limit: 10,
    per_page: 1,
    length: 0,
    transaction_status: [
      {
        text: "Active",
        value: "active",
      },
      {
        text: "Pending",
        value: "pending",
      },
    ],
    transaction_currency: [
      {
        text: "UZS",
        value: "uzs",
      },
      {
        text: "USD",
        value: "usd",
      },
    ],
    balance_type: [
      {
        text: "Cash",
        value: "cash",
      },
      {
        text: "Card",
        value: "card",
      },
    ],
    current_transaction: {
      currency: "uzs",
      balance_type: "cash",
    },
    searchService: "",
    transaction_headers: [],
    create_transaction: false,
    is_valid: false,
    access: null,
    loading_transaction: false,
    supplier_transactions_store: "",
    downExcel: [],
    excel_name: "Transaction",
    wait: true,
    dialog: false,
    max_total: 0,
    data_loading: false,
  }),
  watch: {
    store: {
      deep: true,
      async handler() {
        this.$store.commit("setItemsService", this.store);
        this.invantory_get_supplier();
      },
    },
    per_page() {
      const query = {
        ...this.$route.query,
        page: this.per_page,
      };
      this.$router.push({ path: this.$route.path, query: query });
      this.invantory_get_supplier();
    },
  },
  methods: {
    async invantory_get_supplier() {
      this.data_loading = true;
      const link = `inventory/get_supplier/${this.supplier_id}?service=${
        this.store._id ? this.store._id : ""
      }&limit=${this.limit}&page=${this.per_page}`;
      const supplier = await this.$communicator.getMethodWithAuth(
        link,
        "1.0.0",
        "admin"
      );
      this.length = Math.ceil(supplier.data?.data?.total / this.limit);
      this.max_total = supplier.data?.data?.total;
      if (supplier) this.current_supplier = supplier.data?.data;
      this.data_loading = false;
    },
    async downloadExcel() {
      this.dialog = true;
      const link = `inventory/get_supplier/${this.supplier_id}?service=${
        this.store._id ? this.store._id : ""
      }&limit=${this.max_total}&page=${1}`;
      const supplier = await this.$communicator.getMethodWithAuth(
        link,
        "1.0.0",
        "admin"
      );
      const excel_supplier = await supplier?.data?.data?.transactions.map(
        (sup) => ({
          Document: sup.document_id,
          Date: this.date_ddmmyy_hhmm(sup.date),
          Employee: sup.employee_name,
          Store: sup.service_name,
          Status: sup.status,
          Balance_type: sup.balance_type,
          Credit: sup.balance < 0 ? sup.balance : "",
          Debit: sup.balance > 0 ? sup.balance : "",
        })
      );
      this.downExcel = await excel_supplier;
      setTimeout(() => (this.wait = false), 3000);
    },
    saveExcel() {
      this.dialog = false;
      this.wait = true;
    },
    async exportXLSX() {
      const link = `inventory/get_supplier/${this.supplier_id}?service=${
        this.store._id ? this.store._id : ""
      }&limit=${this.max_total}&page=${1}`;
      const supplier = await this.$communicator.getMethodWithAuth(
        link,
        "1.0.0",
        "admin"
      );
      const excel_supplier = await supplier?.data?.data?.transactions.map(
        (sup) => ({
          Document: sup.document_id,
          Date: this.date_ddmmyy_hhmm(sup.date),
          Employee: sup.employee_name,
          Store: sup.service_name,
          Status: sup.status,
          Balance_type: sup.balance_type,
          Credit: sup.balance < 0 ? sup.balance : "",
          Debit: sup.balance > 0 ? sup.balance : "",
        })
      );
      const ws = xlsx.utils.json_to_sheet(excel_supplier);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(data, "Tansaction.xlsx");
    },
    docClicked(item) {
      this.$router
        .push(`/inventory/purchase/view?id=${item.purchase_id}`)
        .catch(() => {});
    },
    toTransaction() {
      // this.$router.push("/inventory/supplier/transactions");
      this.$router.back();
    },
    async getSupplierById() {
      const supplier = this.$communicator.then(
        this,
        await this.$communicator("supplier", {
          arguments: [this.supplier_id],
        })
      );
      if (supplier) {
        this.current_supplier = supplier;
      } else {
        await this.$router.push("/inventory/supplier/transactions");
      }
    },
    async adjustTransaction() {
      this.loading_transaction = true;
      if (this.current_transaction._id != undefined) {
        const res = this.$communicator.then(
          this,
          await this.$communicator("update_supplier_transaction", {
            arguments: [this.current_transaction._id],
            params: this.current_transaction,
          })
        );
        if (res) {
          this.cancelClicked();
          this.getSupplierById();
        } else {
          this.$router.push("/inventory/supplier/transactions");
        }
      } else {
        const res = this.$communicator.then(
          this,
          await this.$communicator("create_supplier_transaction", {
            params: {
              ...this.current_transaction,
              supplier_id: this.supplier_id,
            },
          })
        );
        if (res) {
          this.$toast.success("Success", { timeout: 2000 });
          this.cancelClicked();
          this.getSupplierById();
        } else {
          this.$router.push("/inventory/supplier/transactions");
        }
      }
      this.loading_transaction = false;
    },
    editTransaction(item) {
      if (item.status == "pending") {
        this.create_transaction = true;
        this.current_transaction = this.$copy(item);
      }
    },
    cancelClicked() {
      this.create_transaction = false;
      this.current_transaction = {
        balance_type: "cash",
        currency: "uzs",
      };
    },
  },
  beforeMount() {
    this.store = this.$store.state.items_current_service;
    this.access = this.$store.state.access;
  },
  mounted() {
    const query = this.$route.query;
    if (query && query.page && query.page != "NaN") {
      this.per_page = parseInt(query.page);
      this.getSupplierById();
    }
    this.transaction_headers = [
      { text: this.$t("document"), value: "document_id" },
      { text: this.$t("date"), value: "date" },
      { text: this.$t("employee"), value: "employee_name" },
      { text: this.$t("store"), value: "service_name" },
      { text: this.$t("status"), value: "status" },
      { text: this.$t("balance_type"), value: "balance_type" },
      { text: this.$t("credit"), value: "balance" },
      { text: this.$t("debt"), value: "debt" },
    ];
  },
};
</script>
